import React from "react";
import {Form} from "../../XLibItems";
import {XInputDecimal} from "@michalrakus/x-react-web-lib/XInputDecimal";
import {XInputText} from "@michalrakus/x-react-web-lib/XInputText";
import {XFormFooter} from "@michalrakus/x-react-web-lib/XFormFooter";
import {XInputDate} from "@michalrakus/x-react-web-lib/XInputDate";
import {XAutoComplete} from "@michalrakus/x-react-web-lib/XAutoComplete";
import {Utils} from "../../Utils";
import {EnumEnum, SluzbaEnum} from "../../common/enums";
import {XFormAutoCompleteColumn, XFormColumn, XFormDataTable2, XFormTextareaColumn} from "@michalrakus/x-react-web-lib/XFormDataTable2";
import {VykazStreetwork} from "../../model/zapisy/vykaz-streetwork.entity";
import {Zapis} from "../../model/zapisy/zapis.entity";
import type {XFormProps} from "@michalrakus/x-react-web-lib/XFormBase";
import {IPostgresInterval, OperationType, XUtils} from "@michalrakus/x-react-web-lib/XUtils";
import {XUserDePaul} from "../../model/user/x-user-de-paul.entity";
import {VykazXUser} from "../../model/zapisy/vykaz-x-user.entity";
import {XErrors} from "@michalrakus/x-react-web-lib/XErrors";
import {FindUsersRequest} from "../../common/user-api";
import {MiestoMoznehoKontaktuBrowse} from "./MiestoMoznehoKontaktuBrowse";
import {MiestoMoznehoKontaktuForm} from "./MiestoMoznehoKontaktuForm";
import {ZapisBaseForm} from "./ZapisBaseForm";
import {XEditor} from "@michalrakus/x-react-web-lib/XEditor";
import {XFormHeader} from "@michalrakus/x-react-web-lib/XFormHeader";
import {XFormScrollable} from "../XFormScrollable";
import {XUtilsCommon} from "@michalrakus/x-react-web-lib/XUtilsCommon";
import {dateAsUI, dateFromModel, numberFromModel} from "@michalrakus/x-react-web-lib/XUtilsConversions";
import {XObject} from "@michalrakus/x-react-web-lib/XObject";
import {XButton} from "@michalrakus/x-react-web-lib/XButton";
import {XBrowseProps} from "@michalrakus/x-react-web-lib/XLazyDataTable";
import {ZapisBrowse} from "./ZapisBrowse";
import {XEnum} from "../../model/user/x-enum.entity";
import {MiestoMoznehoKontaktu} from "../../model/zapisy/miesto-mozneho-kontaktu.entity";
import {UtilsCommon} from "../../common/UtilsCommon";
import {SaveVykazStreetworkHlavickaRequest} from "../../common/zapisy-api";
import {VykazMiestoMoznehoKontaktu} from "../../model/zapisy/vykaz-miesto-mozneho-kontaktu.entity";

// novy formular - iba hlavicka bez zapisov
// vytvorene kopirovanim z VykazStreetworkForm
// bolo by pekne zjednotit spolocny kod ale VykazStreetworkForm mozno casom uplne zahodime
@Form("VykazStreetwork", true)
export class VykazStreetworkHlavickaForm extends ZapisBaseForm {

    userStreetworkList: XUserDePaul[] = [];
    private datumFromEditStart: Date | null = null;
    private miestoMoznehoKontaktuIdListFromEditStart: number[] = [];

    constructor(props: XFormProps) {
        super(props);

        // pri migrovanych zaznamoch zobrazujeme aj tim (readOnly)
        this.addField("tim.name");

        // nacitame aj zapisy, ak existuju, tak datum bude readOnly (efektivnejsie by asi bolo nacitat len pocet v componentDidMount())
        this.addField("zapisList.id");

        this.removeVykazXUser = this.removeVykazXUser.bind(this);
        this.onClickAddRowVykazMestskaCast = this.onClickAddRowVykazMestskaCast.bind(this);
    }

    async componentDidMount() {
        await super.componentDidMount();

        // nacitame si zoznam userov pre stretwork (tych budeme ponukat v autocomplete v casti Pracovnici)
        this.userStreetworkList = await XUtils.fetchMany('find-users', {sluzbaKod: SluzbaEnum.streetwork} satisfies FindUsersRequest);

        this.setStateXForm(); // aby sa prejavili zmeny ktore zavisia od nacitanych zoznamov
    }

    createNewObject(): XObject {
        return {
            datum: XUtilsCommon.today(),
            tim: null,
            vykazXUserList: [], vykazMestskaCastList: [], vykazMiestoMoznehoKontaktuList: [], zapisList: [],
            lockDate: null,
            lockXUser: null
        };
    }

    preInitForm(object: VykazStreetwork, operationType: OperationType.Insert | OperationType.Update) {
        this.datumFromEditStart = dateFromModel(object.datum ?? null);
        this.miestoMoznehoKontaktuIdListFromEditStart = [];
        for (const vykazMiestoMoznehoKontaktu of object.vykazMiestoMoznehoKontaktuList) {
            this.miestoMoznehoKontaktuIdListFromEditStart.push(vykazMiestoMoznehoKontaktu.miestoMoznehoKontaktu.id)
        }
    }


    // pomocna metodka
    private getVykazStreetwork(): VykazStreetwork | null {
        return this.state.object;
    }

    onClickAddRowVykazMestskaCast() {
        this.onTableAddRow("vykazMestskaCastList", {mestskaCast: null, kilometre: null, hodinyCelkovo: null, hodinyVTerene: null});
    };

    // pomocna metodka
    // private getZapisList(): Zapis[] {
    //     const vykazStreetwork: VykazStreetwork = this.getXObject() as VykazStreetwork;
    //     return vykazStreetwork.zapisList;
    // }

    readOnlyDatum(object: VykazStreetwork): boolean {
        return !(object && object.zapisList.length === 0);
    }

    itemTemplateMiestoMoznehoKontaktu(suggestion: MiestoMoznehoKontaktu, index: number, createStringValue: boolean, defaultValue: (suggestion: any) => string): React.ReactNode {
        if (createStringValue) {
            // hodnota do inputu - iba miesto
            return suggestion.miesto;
        }
        else {
            // hodnota do dropdown panelu - dame miesto + mestska cast
            return [suggestion.miesto, suggestion.mestskaCast?.name].join(", ");
        }
    }

    async removeVykazXUser(vykazXUser: VykazXUser) {
        // skontrolujeme, ci mozme vymazat - skontrolujeme (priamo v DB), ci nejaky zapis nema tohto uzivatela zapisaneho v specPoradXUser/specPoradXUser2/psychPoradXUser/pracovnik1XUser/pracovnik2XUser
        if (vykazXUser.xUser) {
            if (!this.isAddRow()) {
                const vykazStreetwork: VykazStreetwork | null = this.getVykazStreetwork();
                if (vykazStreetwork) {
                    // pre jednoduchost nacitame vsetky zaznamy Zapis
                    const zapisList: Zapis[] = await XUtils.fetchRows(
                        'Zapis',
                        {where: `[vykazStreetwork] = ${vykazStreetwork.id}`, params: {}},
                        undefined,
                        ["psychPoradXUser.name", "specPoradXUser.name", "specPoradXUser2.name", "pracovnik1XUser.name", "pracovnik2XUser.name", "klientSluzba.klient.menoPriezviskoPrezyvka"]);
                    for (const zapis of zapisList) {
                        if ((zapis.specPoradXUser && zapis.specPoradXUser.id === vykazXUser.xUser.id)
                            || (zapis.specPoradXUser2 && zapis.specPoradXUser2.id === vykazXUser.xUser.id)) {
                            alert(`Nie je dovolené vymazať pracovníka ${vykazXUser.xUser.name}, pracovník je zapísaný v špecializovanom poradenstve na zázname pre klienta ${zapis.klientSluzba?.klient?.menoPriezviskoPrezyvka}`);
                            return;
                        }
                        if (zapis.psychPoradXUser && zapis.psychPoradXUser.id === vykazXUser.xUser.id) {
                            alert(`Nie je dovolené vymazať pracovníka ${vykazXUser.xUser.name}, pracovník je zapísaný v psychologickom poradenstve na zázname pre klienta ${zapis.klientSluzba?.klient?.menoPriezviskoPrezyvka}`);
                            return;
                        }
                        if ((zapis.pracovnik1XUser && zapis.pracovnik1XUser.id === vykazXUser.xUser.id)
                            || (zapis.pracovnik2XUser && zapis.pracovnik2XUser.id === vykazXUser.xUser.id)) {
                            alert(`Nie je dovolené vymazať pracovníka ${vykazXUser.xUser.name}, pracovník je zapísaný na zázname pre klienta ${zapis.klientSluzba?.klient?.menoPriezviskoPrezyvka}`);
                            return;
                        }
                    }
                }
            }
        }

        // default remove
        this.onTableRemoveRow("vykazXUserList", vykazXUser);
    }

    zobrazitZapisy() {
        const vykazStreetwork: VykazStreetwork | null = this.getVykazStreetwork();
        if (vykazStreetwork) {
            // openForm pridavame automaticky v XFormNavigator3 pri renderovani komponentu (ak neotvarame form v dialogu (ak ho otvarame cez openForm))
            (this.props as XBrowseProps).openForm!(<ZapisBrowse vykazStreetwork={vykazStreetwork}/>);
        }
    }

    // overrides method in XFormBase
    async validate(vykazStreetwork: VykazStreetwork): Promise<XErrors> {
        const errors: XErrors = {};

        // okontrolujeme, ci nevyrabame duplicitny zaznam (nedalo sa nahodit unique constraint koli datam z migracie)
        // TODO - tim sa nepouziva, trebalo by testovat na mnozinu uzivatelov zapisanych na denniku
        const datum: Date | null = vykazStreetwork.datum;
        const tim: XEnum | null = vykazStreetwork.tim;
        if (datum && tim) {
            let vykazStreetworkList: any[] = await XUtils.fetchRows('VykazStreetwork',
                {where: "[datum] = :datum AND [tim] = :timId AND [id] <> :vykazStreetworkId",
                    params: {datum: datum, timId: tim.id, vykazStreetworkId: vykazStreetwork.id ?? 0}});
            if (vykazStreetworkList.length > 0) {
                errors.tim = `Už existuje záznam s dátumom ${dateAsUI(dateFromModel(datum))} a tímom ${tim.name}.`;
            }
        }

        // okontrolujeme, ci nenastala situacia, ze niekto zavesil zapis na hlavicku a uzivatel zaroven zmenil datum
        if (!this.isAddRow()) {
            if (vykazStreetwork.datum) {
                const zapisList: Zapis[] = await XUtils.fetchRows(
                    'Zapis',
                    {where: `[vykazStreetwork] = ${vykazStreetwork.id} AND [datum] <> :datum`, params: {datum: dateFromModel(vykazStreetwork.datum)}});
                if (zapisList.length > 0) {
                    errors.datum = `Nie je dovolené zmeniť dátum, lebo denník už obsahuje aspoň 1 zápis s dátumom ${dateAsUI(dateFromModel(zapisList[0].datum))}`;
                }
            }
        }

        return errors;
    }

    preSave(object: VykazStreetwork) {
        super.preSave(object);

        // vyratame derivovane DB atributy
        let kilometre: number | null = null;
        let hodinyCelkovo: IPostgresInterval | null = null;
        let hodinyVTerene: IPostgresInterval | null = null;
        for (const vykazMestskaCast of object.vykazMestskaCastList) {
            kilometre = UtilsCommon.numberAdd(kilometre, numberFromModel(vykazMestskaCast.kilometre), 0);
            hodinyCelkovo = UtilsCommon.intervalAdd(hodinyCelkovo, vykazMestskaCast.hodinyCelkovo);
            hodinyVTerene = UtilsCommon.intervalAdd(hodinyVTerene, vykazMestskaCast.hodinyVTerene);
        }
        object.kilometre = kilometre;
        object.hodinyCelkovo = hodinyCelkovo;
        object.hodinyVTerene = hodinyVTerene;
    }

    // overridneme standardny saveRow
    async saveRow(): Promise<VykazStreetwork> {
        // pouzivame custom service lebo potrebujeme prepocitavat datum posledneho navstivenia na miestach mozneho kontaktu
        const vykazStreetwork: VykazStreetwork = this.getVykazStreetwork()!;

        // ak sa nezmenil datum, tak staci prepocitat tie miesta ktore boli zmazane z dennika + tie ktore boli pridane na dennik (t.j. vylucime prienik)
        // ak sa zmenil datum, treba preratat vsetky miesta na denniku (aj tie ktore boli zmazane)
        let miestoMoznehoKontaktuIdList: number[];
        if (XUtilsCommon.dateEquals(this.datumFromEditStart, dateFromModel(vykazStreetwork.datum))) {
            miestoMoznehoKontaktuIdList = XUtilsCommon.numberArraySymmetricDiff(this.miestoMoznehoKontaktuIdListFromEditStart, vykazStreetwork.vykazMiestoMoznehoKontaktuList.map((value: VykazMiestoMoznehoKontaktu) => value.miestoMoznehoKontaktu.id));
        }
        else {
            miestoMoznehoKontaktuIdList = XUtilsCommon.numberArrayUnion(this.miestoMoznehoKontaktuIdListFromEditStart, vykazStreetwork.vykazMiestoMoznehoKontaktuList.map((value: VykazMiestoMoznehoKontaktu) => value.miestoMoznehoKontaktu.id));
        }

        const reload: boolean = this.props.onSaveOrCancel !== undefined;
        const request: SaveVykazStreetworkHlavickaRequest = {vykazStreetwork: vykazStreetwork, miestoMoznehoKontaktuIdListForRecalc: miestoMoznehoKontaktuIdList, reload: reload};
        // fetch (na rozdiel od post) spracuva response (konvertuje do json objektu)
        return await XUtils.fetch('save-vykaz-streetwork-hlavicka', request);
    }

    renderDesktop() {
        return (
            <div>
                <XFormScrollable form={this} headerFooterHeight="8rem" widthFitContent={true}>
                    <div className="x-form-row">
                        <div className="x-form-col">
                            <div className="x-form-row">
                                <XInputDate form={this} field="datum" label="Dátum" labelStyle={{width:'6rem'}} readOnly={this.readOnlyDatum}/>
                                <XFormHeader form={this} label="Denník" style={{marginTop: '0rem', marginBottom: '1rem', marginLeft: '2rem', marginRight: '1.5rem'}}/>
                                <div className="x-form-inline-row">
                                    <XInputDate form={this} field="modifDate" label="Modif." labelStyle={{width:'4.5rem'}} readOnly={true}/>
                                    <XInputText form={this} field="modifXUser.name" labelStyle={{width:'0rem'}} inputStyle={{width:'10rem'}} readOnly={true}/>
                                    {!this.isAddRow() ? <XInputDecimal form={this} field="id" labelStyle={{width:'0rem'}} inputStyle={{width:'4rem'}} readOnly={true}/> : null}
                                </div>
                            </div>
                            <div className="x-form-row">
                                <div className="x-form-col">
                                    <XAutoComplete form={this} assocField="palivoVIgnise" displayField="name" label="Palivo v Ignise" labelStyle={{width:'10.5rem'}}
                                                   filter={Utils.enumFilter(EnumEnum.palivoVIgnise)} sortField="enumOrder" width="7.35rem"/>
                                    {this.getVykazStreetwork()?.tim ? <XInputText form={this} field="tim.name" label="Tím (z migrácie)" labelStyle={{width:'10.5rem'}} inputStyle={{width:'7.35rem'}} readOnly={true}/> : <div/>}
                                    <XFormDataTable2 form={this} assocField="vykazXUserList"
                                                     onClickRemoveRow={this.removeVykazXUser}>
                                        <XFormColumn field="id" header="ID" readOnly={true} width="3rem" columnViewStatus={false}/>
                                        <XFormAutoCompleteColumn assocField="xUser" displayField="name" header="Pracovník" width="15rem"
                                                                 suggestions={this.userStreetworkList}/>
                                    </XFormDataTable2>
                                </div>
                                <div className="x-form-col">
                                    <XFormDataTable2 form={this} assocField="vykazMestskaCastList" label="Mestské časti - kilometre, hodiny"
                                                     onClickAddRow={this.onClickAddRowVykazMestskaCast}>
                                        <XFormAutoCompleteColumn assocField="mestskaCast" displayField="name" header="Mestská časť" width="12rem" filter={Utils.miestoMoznehoKontaktuMestskaCastFilter()}/>
                                        <XFormColumn field="kilometre" header="Kilometre" width="6rem"/>
                                        <XFormColumn field="hodinyCelkovo" header="Hodiny celkovo" width="8rem"/>
                                        <XFormColumn field="hodinyVTerene" header="Hodiny v teréne" width="8rem"/>
                                    </XFormDataTable2>
                                </div>
                            </div>{/* x-form-row pre stlpce */}
                            <XFormDataTable2 form={this} assocField="vykazMiestoMoznehoKontaktuList" label="Miesta možného kontaktu">
                                <XFormColumn field="miestoMoznehoKontaktu.mestskaCast.name" header="Mestská časť" readOnly={true} width="10rem"/>
                                <XFormAutoCompleteColumn assocField="miestoMoznehoKontaktu" displayField={["miesto", "mestskaCast.name"]} fields={["mestskaCast.name"]}
                                                         itemTemplate={this.itemTemplateMiestoMoznehoKontaktu}
                                                         suggestionsLoad="lazy" lazyLoadMaxRows={30}
                                                         header="Miesto možného kontaktu" width="24rem" scrollHeight="24rem"
                                                         filter={XUtilsCommon.filterAnd(Utils.filterCurrentSluzba(), {where: `[aktivne] = TRUE`, params: {}})}
                                                         searchBrowse={<MiestoMoznehoKontaktuBrowse/>} assocForm={<MiestoMoznehoKontaktuForm/>}/>
                                <XFormTextareaColumn field="miestoMoznehoKontaktu.poznamka" header="Poznámka" readOnly={true} width="20rem"/>
                            </XFormDataTable2>
                            <XEditor form={this} field="priebehSluzby" label="Priebeh služby" labelOnTop={true} inputStyle={{width: '100%', maxWidth: '56rem'}}/>
                            {!this.isInDialog() ?
                                <div className="flex justify-content-center">
                                    {/*    <XButtonIconMedium icon="pi pi-check" onClick={() => this.addZapis()}/> */}
                                    <XButton label={`Zápisy (${this.state.object?.zapisList.length ? this.state.object?.zapisList.length : 0})`}
                                             disabled={this.state.object?.zapisList.length === 0}
                                             onClick={() => this.zobrazitZapisy()} style={{backgroundColor:'green'}}/>
                                </div>
                            : null}
                        </div>
                    </div>
                </XFormScrollable>
                <XFormFooter form={this}/>
            </div>
        );
    }

    // TODO - bolo by fajn pridat label + tlacitko na zobrazenie modif atributov (vedla datumu)
    renderMobile() {
        return (
            <div>
                <XFormHeader form={this} label="Denník"/>
                <XFormScrollable form={this} headerFooterHeight="11.5rem" widthFitContent={true}>
                    <div className="x-form-row">
                        <div className="x-form-col">
                            <XInputDate form={this} field="datum" label="Dátum" labelStyle={{width:'10.5rem'}} readOnly={this.readOnlyDatum}/>
                            <XAutoComplete form={this} assocField="palivoVIgnise" displayField="name" label="Palivo v Ignise" labelStyle={{width:'10.5rem'}}
                                           filter={Utils.enumFilter(EnumEnum.palivoVIgnise)} sortField="enumOrder" width="8.35rem"/>
                            {this.getVykazStreetwork()?.tim ? <XInputText form={this} field="tim.name" label="Tím (z migrácie)" labelStyle={{width:'10.5rem'}} inputStyle={{width:'8.35rem'}} readOnly={true}/> : <div/>}
                            <XFormDataTable2 form={this} assocField="vykazXUserList"
                                             onClickRemoveRow={this.removeVykazXUser}>
                                <XFormColumn field="id" header="ID" readOnly={true} width="3rem" columnViewStatus={false}/>
                                <XFormAutoCompleteColumn assocField="xUser" displayField="name" header="Pracovník" width="15rem"
                                                         suggestions={this.userStreetworkList}/>
                            </XFormDataTable2>
                            <div style={{height: '1rem'}}/>
                            <XFormDataTable2 form={this} assocField="vykazMestskaCastList" label="Mestské časti - kilometre, hodiny">
                                <XFormAutoCompleteColumn assocField="mestskaCast" displayField="name" header="Mestská časť" width="12rem" filter={Utils.miestoMoznehoKontaktuMestskaCastFilter()}/>
                                <XFormColumn field="kilometre" header="Km" width="3rem"/>
                                <XFormColumn field="hodinyCelkovo" header="Hod celk." width="5rem"/>
                                <XFormColumn field="hodinyVTerene" header="Hod terén" width="5rem"/>
                            </XFormDataTable2>
                            <div style={{height: '1rem'}}/>
                            <XFormDataTable2 form={this} assocField="vykazMiestoMoznehoKontaktuList" label="Miesta možného kontaktu">
                                <XFormColumn field="miestoMoznehoKontaktu.mestskaCast.name" header="Mestská časť" readOnly={true} width="8rem"/>
                                <XFormAutoCompleteColumn assocField="miestoMoznehoKontaktu" displayField={["miesto", "mestskaCast.name"]} fields={["mestskaCast.name"]}
                                                         itemTemplate={this.itemTemplateMiestoMoznehoKontaktu}
                                                         suggestionsLoad="lazy" lazyLoadMaxRows={30}
                                                         header="Miesto možného kontaktu" width="20rem" scrollHeight="20rem"
                                                         filter={XUtilsCommon.filterAnd(Utils.filterCurrentSluzba(), {where: `[mestskaCast] IS NOT NULL`, params: {}})}
                                                         searchBrowse={<MiestoMoznehoKontaktuBrowse/>} assocForm={<MiestoMoznehoKontaktuForm/>}/>
                                <XFormColumn field="miestoMoznehoKontaktu.poznamka" header="Poznámka" readOnly={true} width="20rem"/>
                            </XFormDataTable2>
                            <XEditor form={this} field="priebehSluzby" label="Priebeh služby" labelOnTop={true}/>
                            {!this.isInDialog() ?
                                <div className="flex justify-content-center">
                                    {/*    <XButtonIconMedium icon="pi pi-check" onClick={() => this.addZapis()}/> */}
                                    <XButton label={`Zápisy (${this.state.object?.zapisList.length ? this.state.object?.zapisList.length : 0})`}
                                             disabled={this.state.object?.zapisList.length === 0}
                                             onClick={() => this.zobrazitZapisy()} style={{backgroundColor:'green'}}/>
                                </div>
                                : null}
                        </div>
                    </div>
                </XFormScrollable>
                <XFormFooter form={this}/>
            </div>
        );
    }

    render() {
        if (!XUtils.isMobile()) {
            return this.renderDesktop();
        } else {
            return this.renderMobile();
        }
    }
}
